<template>
  <div class="home" @click="hideList">
    <div class="content1">
      <div class="contain">
        <div class="txt">
          <div class="logoIcon">
            <img src="../../assets/icon/logoIcon1.png" alt="../../assets/icon/logoIcon1@2x.png 2x">
          </div>
          <h3>Maro Connect</h3>
          <p>{{$t('content1_txt')}}</p>
          <div v-show="showBtns" class="btns clearfix">
            <a @mouseover="showQrBoxIOS = true;" class="fl" href="https://apps.apple.com/us/app/ttc-connect-pro/id1479804338">
              <img src="../../assets/icon/iOS.png" srcset="../../assets/icon/iOS@2x.png 2x" class="icon">
              <span>iOS</span>
              <div v-show="showQrBoxIOS" @mouseleave="showQrBoxIOS = false; showBtns = true;" class="qrBox clearfix">
                <div class="down fl">
                  <div class="tit">Maro Connect</div>
                  <a href="https://apps.apple.com/us/app/ttc-connect-pro/id1479804338" target="_blank">{{$t('content1_download')}}</a>
                </div>
                <div class="code fr">
                  <img src="../../assets/img/maro-qr.png" alt="">
                </div>
              </div>
            </a>
            <a @mouseover="showQrBoxAND = true;" class="fl" href="https://play.google.com/store/apps/details?id=com.ttc.wallet&hl=en_US">
              <img src="../../assets/icon/anh.png" srcset="../../assets/icon/anh@2x.png 2x" class="icon">
              <span>Android</span>
              <div v-show="showQrBoxAND" @mouseleave="showQrBoxAND = false; showBtns = true;" class="qrBox clearfix">
                <div class="down fl">
                  <div class="tit">Maro Connect</div>
                  <a href="https://play.google.com/store/apps/details?id=com.ttc.wallet&hl=en_US" target="_blank">{{$t('content1_download')}}</a>
                </div>
                <div class="code fr">
                  <img src="../../assets/img/maro-qr.png" alt="">
                </div>
              </div>
            </a>
          </div>
          <div class="download">
            <a href="https://wallet.ttc.eco/download">{{$t('content1_download')}}</a>
          </div>
        </div>
        <div class="pic">
          <img src="../../assets/img/iphone.png" alt="../../assets/img/iphone@2x.png 2x">
        </div>
      </div>
      <div class="whiteTiao">
        <div class="tiao" :style="{backgroundImage: 'url(' + imgTiao + ')'}"></div>
      </div>
    </div>
    <div class="content2">
      <div class="contain">
        <h3>{{$t('content2_h3')}}</h3>
        <p class="txt mb80">{{$t('content2_p')}}</p>
        <div class="three clearfix">
          <div class="w30 fl">
            <div class="pic">
              <img src="../../assets/img/three1.png" alt="">
            </div>
            <h5>{{$t('content2_h5_1')}}</h5>
            <p class="txt">{{$t('content2_txt_1')}}</p>
          </div>
          <div class="w30 fl">
            <div class="pic">
              <img src="../../assets/img/three2.png" alt="">
            </div>
            <h5>{{$t('content2_h5_2')}}</h5>
            <p class="txt">{{$t('content2_txt_2')}}</p>
          </div>
          <div class="w30 fl">
            <div class="pic">
              <img src="../../assets/img/three3.png" alt="">
            </div>
            <h5>{{$t('content2_h5_3')}}</h5>
            <p class="txt">{{$t('content2_txt_3')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content3">
      <div class="contain">
        <h3>{{$t('content3_h3')}}</h3>
        <p class="txt mb80">{{$t('content3_p')}}</p>
        <div>
          <a class="link" href="https://ma.ro/#/">{{$t('content3_link')}}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../../bus'
export default {
  data () {
    return {
      imgTiao: require('../../assets/img/tiao.png'),
      showQrBoxIOS: false,
      showQrBoxAND: false,
      showBtns: true
    }
  },
  methods: {
    hideList () {
      Bus.$emit('hideLangList', false)
    }
  }
}
</script>
<style lang="less" scoped>
.home{
  .content1{
    background: #333D46;
    position: relative;
    .contain{
      position: relative;
      height: 980px;
      overflow: hidden;
      .txt{
        padding-top: 320px;
        max-width: 760px;
        .logoIcon{
          display: none;
          width: 80px;
          height: 80px;
          margin-bottom: 10px;
        }
        h3{
          margin-bottom: 20px;
        }
        p{
          margin-bottom: 60px;
        }
        .btns{
          a{
            position: relative;
            width: 237px;
            height: 64px;
            background: #FFFFFF;
            border-radius: 2px;
            display: block;
            font-size: 24px;
            font-family: Montserrat-SemiBold, Montserrat;
            font-weight: 600;
            color: #333D46;
            line-height: 64px;
            text-align: center;
            margin-right: 20px;
            margin-bottom: 20px;
            img{
              display: inline;
              vertical-align: text-bottom;
            }
          }
        }
        .qrBox{
          position: absolute;
          top: 0;
          left: 0;
          z-index: 100;
          width: 618px;
          height: 208px;
          background: #ffffff;
          padding: 30px;
          box-sizing: border-box;
          border-radius: 2px;
          .down{
            .tit{
              font-size: 22px;
              font-family: Montserrat-SemiBold, Montserrat;
              font-weight: 600;
              color: #333D46;
              line-height: 27px;
              margin-bottom: 20px;
            }
            a{
              width: 224px;
              height: 64px;
              background: #333D46;
              border-radius: 2px;
              font-size: 22px;
              font-family: Montserrat-SemiBold, Montserrat;
              font-weight: 600;
              color: #FFFFFF;
              line-height: 64px;
              display: block;
              text-align: center;
            }
          }
          .code{
            width: 148px;
          }
        }
        .download{
          display: none;
          a{
            width: 136px;
            height: 48px;
            background: #FFFFFF;
            border-radius: 2px;
            line-height: 48px;
            text-align: center;
            font-size: 18px;
            font-family: Montserrat-SemiBold, Montserrat;
            font-weight: 600;
            color: #333D46;
            display: block;
          }
        }
      }
      .pic{
        display: block;
        max-width: 760px;
        position: absolute;
        right: 0;
        top: 210px;
      }
    }
    .whiteTiao{
      position: absolute;
      bottom: -1px;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 125px;
      overflow: hidden;
      .tiao{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 200%;
        height: 100%;
        background-repeat: repeat no-repeat;
        background-position: 0 bottom;
        transform-origin: center bottom;
        background-size: 50% 125px;
        animation: move_wave 10s linear infinite;
      }
    }
  }
  .content2{
    padding-top: 50px;
    background: #ffffff;
    .contain{
      h3{
        color: #333D46;
        max-width: 1060px;
        margin-bottom: 20px;
      }
      .mb80{
        margin-bottom: 80px;
      }
      .three{
        margin-bottom: 240px;
        .w30{
          width: 30%;
          margin-right: 5%;
          &:last-child{
            margin-right: 0;
          }
          .pic{
            width: 140px;
            margin-bottom: 40px;
          }
          h5{
            margin-bottom: 40px;
          }
        }
      }
    }
  }
  .content3{
    background: #ffffff;
    padding-bottom: 240px;
    .contain{
      h3{
        max-width: 960px;
        color: #333D46;
        margin-bottom: 20px;
      }
      .txt{
        max-width: 960px;
      }
    }
  }
}
@media screen and (max-width:1919px){
  .home{
    .content1{
      .contain{
        height: 880px;
        .txt{
          padding-top: 220px;
          max-width: 560px;
        }
        .pic{
          max-width: 560px;
          top: 220px;
        }
      }
    }
  }
}
@media screen and (max-width:1439px){
  .home{
    .content1{
      .contain{
        .txt{
          p{
            max-width: 460px;
          }
          .btns{
            max-width: 460px;
          }
        }
        .pic{
          max-width: 446px;
          top: 276px;
        }
      }
    }
  }
}
@media screen and (max-width:1199px){
  .home{
    .content1{
      .contain{
        .txt{
          max-width: 360px;
          p{
            color:rgba(255, 255, 255, 0.5);
            margin-bottom: 40px;
          }
          .btns{
            a{
              width: 170px;
              height: 48px;
              font-size: 16px;
              line-height: 48px;
              &:last-child{
                margin-right: 0;
              }
              .icon{
                width: 20px;
              }
            }
          }
        }
        .pic{
          max-width: 310px;
          top: 180px;
        }
      }
    }
    .content2{
      .contain{
        .three{
          margin-bottom: 200px;
          .w30{
            width: 360px;
            margin-right: 40px;
            &:nth-child(2){
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width:999px){
  .home{
    .content1{
      height: 100vh;
      min-height: 667px;
      .contain{
        height: auto;
        .txt{
          padding-top: 153px;
          .logoIcon{
            display: block;
          }
          .btns{
            display: none;
          }
          .download{
            display: block;
            margin-bottom: 153px;
          }
        }
        .pic{
          display: none;
        }
      }
      .whiteTiao{
        .tiao{
          width: 700%;
        }
      }
    }
    .content2{
      padding-top: 20px;
      .contain{
        .txt{
          margin-bottom: 40px;
        }
        .three{
          margin-bottom: 100px;
          .w30{
            width: 100%;
            margin-right: 0;
            .pic{
              width: 70px;
              margin-bottom: 18px;
            }
            h5{
              margin-bottom: 20px;
            }
          }
        }
      }
    }
    .content3{
      padding-bottom: 140px;
      .contain{
        h3{
          margin-bottom: 10px;
        }
        .mb80{
          margin-bottom: 45px;
        }
      }
    }
  }
}
@keyframes move_wave {
  0% {
    transform: translateX(0) translateZ(0) scaleY(1)
  }
  50% {
    transform: translateX(25%) translateZ(0) scaleY(0.55)
  }
  100% {
    transform: translateX(50%) translateZ(0) scaleY(1)
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue